import { trim } from '@app/utils/stringUtils';
import { ACCOUNT_FIELD_MAX_LENGTH, INFORMATION_FIELD_MAX_LENGTH, VALIDATION_PATTERNS } from '@app/domain/uiConsts';
import { SupplierRegistrationCountryFields } from '@supplierRegistration/domain/supplierRegistrationCountryFields';
import { SupplierRegistrationField } from '@supplierRegistration/domain/supplierRegistrationAccountDetailsFields';

export enum IndiaLegalIdTypesForCompany {
  GSTIN = 'GSTIN',
  PAN = 'PAN',
  Other = 'Other',
}

function getBankCodeFields(): SupplierRegistrationField {
  // the IFSC code is mandatory for every India account and must be exactly 11 alphanumeric characters
  return {
    id: 'inpt-supp-reg-IN-ifsc-code',
    inputType: 'text',
    decoratorRules: [
      {
        required: true,
        transform: trim,
        translatedMessage: [
          'supplierValidation.supplierRegister.IN.errors.missingBankCode',
          'supplierValidation.supplierRegister.errors.missingBankCode',
        ],
      },
      {
        len: ACCOUNT_FIELD_MAX_LENGTH.IN.IFSC,
        transform: trim,
        translatedMessage: {
          key: 'supplierValidation.supplierRegister.IN.errors.bankCodeExactLength',
          value: ACCOUNT_FIELD_MAX_LENGTH.IN.IFSC,
        },
      },
      {
        pattern: VALIDATION_PATTERNS.alphanumeric,
        transform: trim,
        translatedMessage: [
          `supplierValidation.supplierRegister.IN.errors.invalidBankCode`,
          'supplierValidation.supplierRegister.errors.invalidBankCode',
        ],
      },
    ],
  };
}

export const IN: SupplierRegistrationCountryFields = {
  leis: { types: IndiaLegalIdTypesForCompany },
  legalIdTypesForCompany: [
    {
      key: IndiaLegalIdTypesForCompany.GSTIN,
      rules: [
        {
          required: true,
          transform: trim,
          translatedMessage: 'supplierValidation.supplierRegister.errors.missingLegalIdValue',
        },
        {
          len: INFORMATION_FIELD_MAX_LENGTH.IN.GSTIN,
          transform: trim,
          translatedMessage: `supplierValidation.supplierRegister.IN.errors.gstinLength`,
        },
        {
          pattern: VALIDATION_PATTERNS.alphanumeric,
          transform: trim,
          translatedMessage: `supplierValidation.supplierRegister.IN.errors.gstinLength`,
        },
      ],
    },
    {
      key: IndiaLegalIdTypesForCompany.PAN,
      rules: [
        {
          required: true,
          transform: trim,
          translatedMessage: 'supplierValidation.supplierRegister.errors.missingLegalIdValue',
        },
        {
          len: INFORMATION_FIELD_MAX_LENGTH.IN.PAN,
          transform: trim,
          translatedMessage: `supplierValidation.supplierRegister.IN.errors.panLength`,
        },
        {
          pattern: VALIDATION_PATTERNS.alphanumeric,
          transform: trim,
          translatedMessage: `supplierValidation.supplierRegister.IN.errors.panLength`,
        },
      ],
    },
  ],
  bankCode: getBankCodeFields,
};
